// @flow
import * as types from "../constants/action-types";
import initialState from "./initial-state";
import TrashDrop from "../models/trash-drop";
import * as R from "ramda";


export const eventInfoReducer = R.cond([
    [
        (state, action) => (action.type === types.FETCH_EVENT_INFO_FAIL),
        (state, action) => ({
            ...state,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.FETCH_EVENT_INFO_SUCCESS),
        (state, action) => ({
            ...state,
            data: action.payload.data,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.UPDATE_EVENT_INFO_FAIL),
        (state, action) => ({
            ...state,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.UPDATE_EVENT_INFO_SUCCESS),
        (state, action) => {
            const myNewTrashDrop = TrashDrop.create({ ...state.data[action.payload.id], ...action.payload.snippet });
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.payload.id]: myNewTrashDrop
                },

                error: null
            };
        }
    ],
    [
        (state, action) => (action.type === types.RESET),
        () => initialState.eventInfo
    ],
    [
        R.T,
        state => (state || initialState.eventInfo)
    ]
]);